export default "__VITE_ASSET__Dpii$oRT__"